import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-more-horizontal-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round">
      <circle cx="12" cy="12" r="1" fill="currentColor" />
      <circle cx="19" cy="12" r="1" fill="currentColor" />
      <circle cx="5" cy="12" r="1" fill="currentColor" />
    </svg>
  `,
})
export class MoreHorizontalIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 24 24');
}
